import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
  cursor: pointer;

  svg.fa-suitcase,
  svg.fa-users {
    font-size: 1.8em;
  }
`;

export { Wrapper as default };
